import React from "react";

export default function PlaceBetUniversal({
  placeBetPayload,
  setPlaceBetPayload,
  placeBet,
}) {
  return (
    <tr _ngcontent-ng-c2991413133="" className="ng-star-inserted">
      <td _ngcontent-ng-c2991413133="" className="ng-star-inserted" colSpan={4}>
        <app-betslips
          _ngcontent-ng-c2991413133=""
          style={{ padding: 0 }}
          _nghost-ng-c4065501593=""
        >
          <div _ngcontent-ng-c4065501593="" className="fancy-quick-tr placebet">
            <div
              _ngcontent-ng-c4065501593=""
              className={`pb-1 place-bet paddtp slip-${placeBetPayload?.type}`}
            >
              <div _ngcontent-ng-c4065501593="" className="container">
                <div _ngcontent-ng-c4065501593="" className="row pb-0 pt-0">
                  <div
                    _ngcontent-ng-c4065501593=""
                    className="col-6 text-bold inputset padd-0"
                  >
                    <div _ngcontent-ng-c4065501593="" className="priceClass">
                      <button
                        _ngcontent-ng-c4065501593=""
                        disabled=""
                        className="stakeactionminus1 btn betButtonMinus"
                        style={{ position: "absolute", left: 0 }}
                      >
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonMinus"
                        >
                          <svg
                            _ngcontent-ng-c4065501593=""
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            enableBackground="new 0 0 19 19"
                            xmlSpace="preserve"
                          >
                            <g _ngcontent-ng-c4065501593="">
                              <path
                                _ngcontent-ng-c4065501593=""
                                fill="currentColor"
                                d="M8.056,10.838H0.409V8.091h7.647 M2,8.091h16.591v2.747H8"
                              />
                            </g>
                          </svg>
                        </span>
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonMinus"
                        />
                      </button>
                      <input
                        _ngcontent-ng-c4065501593=""
                        disabled=""
                        type="text"
                        value={placeBetPayload[placeBetPayload?.type] || ""}
                        onChange={(e) => {
                          setPlaceBetPayload({
                            ...placeBetPayload,
                            [placeBetPayload[placeBetPayload?.type]]:
                              e.target.value,
                          });
                        }}
                        className="stakeinput quick-bet-confirm text-center"
                      />
                      <button
                        _ngcontent-ng-c4065501593=""
                        disabled=""
                        className="stakeactionplus1 btn betButtonPlus"
                        style={{ position: "absolute", right: 0 }}
                      >
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonPlus"
                        >
                          <svg
                            _ngcontent-ng-c4065501593=""
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            enableBackground="new 0 0 19 19"
                            xmlSpace="preserve"
                          >
                            <g _ngcontent-ng-c4065501593="">
                              <path
                                _ngcontent-ng-c4065501593=""
                                fill="currentColor"
                                d="M10.946,0.127v7.964h7.646v2.747h-7.646v8.035h-2.89v-8.035H0.409V8.091h7.647V0.127H10.946z"
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                  <div
                    _ngcontent-ng-c4065501593=""
                    className="col-6 text-bold inputset padd-0"
                  >
                    <div _ngcontent-ng-c4065501593="" className="priceClass">
                      <button
                        _ngcontent-ng-c4065501593=""
                        className="stakeactionminus btn betButtonMinus"
                        style={{ position: "absolute", left: 0 }}
                        onClick={() => {
                        
                          setPlaceBetPayload({
                            ...placeBetPayload,
                            amount:
                              placeBetPayload?.amount -
                              (placeBetPayload?.amount % 2 == 0
                                ? placeBetPayload?.amount / 2
                                : placeBetPayload?.amount),
                          });
                        }}
                      >
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonMinus"
                        >
                          <svg
                            _ngcontent-ng-c4065501593=""
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            enableBackground="new 0 0 19 19"
                            xmlSpace="preserve"
                          >
                            <g _ngcontent-ng-c4065501593="">
                              <path
                                _ngcontent-ng-c4065501593=""
                                fill="currentColor"
                                d="M8.056,10.838H0.409V8.091h7.647 M2,8.091h16.591v2.747H8"
                              />
                            </g>
                          </svg>
                        </span>
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonMinus"
                        />
                      </button>
                      <input
                        _ngcontent-ng-c4065501593=""
                        id="betAmount"
                        type="number"
                        value={placeBetPayload.amount}
                        onChange={(e) => {
                          setPlaceBetPayload({
                            ...placeBetPayload,
                            amount: e.target.value,
                          });
                        }}
                        className="stakeinput input-Betslip text-center ng-untouched ng-pristine ng-valid"
                      />
                      <button
                        _ngcontent-ng-c4065501593=""
                        className="stakeactionplus btn betButtonPlus"
                        style={{ position: "absolute", right: 0 }}
                        onClick={() => {
                          setPlaceBetPayload({
                            ...placeBetPayload,
                            amount:
                              placeBetPayload.amount + placeBetPayload.amount,
                          });
                        }}
                      >
                        <span
                          _ngcontent-ng-c4065501593=""
                          className="betButtonPlus"
                        >
                          <svg
                            _ngcontent-ng-c4065501593=""
                            version="1.1"
                            id="Layer_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            enableBackground="new 0 0 19 19"
                            xmlSpace="preserve"
                          >
                            <g _ngcontent-ng-c4065501593="">
                              <path
                                _ngcontent-ng-c4065501593=""
                                fill="currentColor"
                                d="M10.946,0.127v7.964h7.646v2.747h-7.646v8.035h-2.89v-8.035H0.409V8.091h7.647V0.127H10.946z"
                              />
                            </g>
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div _ngcontent-ng-c4065501593="" className="row stackbutton">
                  {/**/}
                  {[100, 500, 1000, 5000, 10000, 25000, 50000, 100000]?.map(
                    (amount) => (
                      <div
                        _ngcontent-ng-c4065501593=""
                        className="col-3 p-1 stack-inputs"
                        onClick={() => {
                          setPlaceBetPayload({
                            ...placeBetPayload,
                            amount,
                          });
                        }}
                      >
                        <a
                          _ngcontent-ng-c4065501593=""
                          className="btn btn-block fancy-quick-btn"
                        >
                          {amount}
                        </a>
                      </div>
                    )
                  )}
                </div>
                <div
                  _ngcontent-ng-c4065501593=""
                  className="row mt-0 pb-0 pt-0 stackbutton"
                >
                  <div
                    onClick={() => {
                      setPlaceBetPayload(null);
                    }}
                    _ngcontent-ng-c4065501593=""
                    className="col-6 p-1 pb-0"
                  >
                    <a
                      _ngcontent-ng-c4065501593=""
                      className="btn btn-secondary btn-block btn-cancel"
                    >
                      {" "}
                      Cancel{" "}
                    </a>
                  </div>
                  <div _ngcontent-ng-c4065501593="" className="col-6 p-1 pb-0">
                    <button
                      _ngcontent-ng-c4065501593=""
                      className="btn btn-send btn-send-active"
                      onClick={placeBet}
                      disabled={placeBetPayload.amount === 0}
                    >
                      {" "}
                      Place Bet{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**/}
          {/**/}
        </app-betslips>
      </td>
    </tr>
  );
}
